import useRepo from '@/nebula/repo';
import { accessGroup as accessGroupConfig } from 'shared/api/query/configs.json';

export default function useAccessGroup() {
  const repo = useRepo(accessGroupConfig.model);

  return { ...repo, accessGroups: repo.entityList };
}
